import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Newspaper, FileText, ChevronLeft, BarChart3, SlidersHorizontal, Cable, Home, Layers, BookOpen, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';
interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}
const navSections = [{
  title: null,
  items: [{
    icon: Home,
    label: 'Panoramica',
    path: '/home'
  }, {
    icon: Newspaper,
    label: 'Rassegne',
    path: '/rassegne'
  }, {
    icon: BarChart3,
    label: 'Statistiche',
    path: '/statistics'
  }, {
    icon: FileText,
    label: 'Report',
    path: '/reports'
  }, {
    icon: TrendingUp,
    label: 'Analisi predittiva',
    path: '/predictive'
  }, {
    icon: BookOpen,
    label: 'Definizioni',
    path: '/definitions'
  }]
}, {
  title: 'CONFIGURAZIONE',
  items: [{
    icon: SlidersHorizontal,
    label: 'Algoritmo',
    path: '/settings/algorithm'
  }, {
    icon: Cable,
    label: 'Connettori',
    path: '/settings/connectors'
  }, {
    icon: Layers,
    label: 'Gestione Tier',
    path: '/settings/tiers'
  }]
}];
export function Sidebar({
  collapsed,
  onToggle
}: SidebarProps) {
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);
  return <div className={`h-full flex flex-col transition-all duration-300 ${collapsed ? 'w-16' : 'w-64'}`} style={{
    backgroundColor: '#1AA0DB',
    borderRight: '1px solid rgba(255,255,255,0.18)',
    color: '#FFFFFF'
  }} data-id="element-245">
      {/* Header */}
      <div className="p-4 flex items-center justify-between" data-id="element-246">
        {!collapsed && <div className="flex items-center px-1" data-id="element-247">
            <img src="https://cdn.magicpatterns.com/uploads/s2MFPhMtmvBfy6H1KoBtds/Unione_Comunita_Ebraiche_Italiane_-_logo_(Italy).svg" alt="UCEI — Unione delle Comunità Ebraiche Italiane" className="h-14 w-auto object-contain" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-248" />
          </div>}
        {collapsed && <div className="flex items-center justify-center w-full" data-id="element-249">
            <span className="font-logo text-[20px] font-bold tracking-tight" style={{
          color: '#FFFFFF'
        }} data-id="element-250">
              UCEI
            </span>
          </div>}
        <Button variant="ghost" size="icon-sm" onClick={onToggle} className="ml-auto text-white hover:text-white hover:bg-white/10" data-id="element-251">
          <ChevronLeft className={`h-4 w-4 transition-transform ${collapsed ? 'rotate-180' : ''}`} data-id="element-252" />
        </Button>
      </div>

      <div style={{
      borderTop: '1px solid rgba(255,255,255,0.18)'
    }} data-id="element-253" />

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-2 space-y-6" data-id="element-254">
        {navSections.map((section, idx) => <div key={idx} data-id="element-255">
            {!collapsed && <div className="px-3 py-2 text-[11px] uppercase tracking-wider" style={{
          color: 'rgba(255,255,255,0.65)'
        }} data-id="element-256">
                {section.title}
              </div>}
            <div className="space-y-0.5" data-id="element-257">
              {section.items.map(item => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return <Link key={item.path} to={item.path} className="block" data-id="element-258">
                    <button className="w-full flex items-center gap-3 px-3 py-2.5 transition-colors border-l-2" style={{
                borderColor: active ? '#FFFFFF' : 'transparent',
                color: active ? '#FFFFFF' : 'rgba(255,255,255,0.85)',
                backgroundColor: active ? 'rgba(255,255,255,0.18)' : 'transparent'
              }} onMouseEnter={e => {
                if (!active) {
                  e.currentTarget.style.color = '#FFFFFF';
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.12)';
                }
              }} onMouseLeave={e => {
                if (!active) {
                  e.currentTarget.style.color = 'rgba(255,255,255,0.85)';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }} data-id="element-259">
                      <Icon className="h-4 w-4 flex-shrink-0" style={{
                  color: '#FFFFFF'
                }} data-id="element-260" />
                      {!collapsed && <span className="text-sm font-medium" data-id="element-261">
                          {item.label}
                        </span>}
                    </button>
                  </Link>;
          })}
            </div>
          </div>)}
      </nav>
    </div>;
}